<!-- 我的消息 -->
<template>
	<div class="content-main">
		<WNav />
		<div class="center-box">
			<Back />
			<div class="word content-box">
				<!-- tab -->
				<div class="top-tab">
					<div data-tabindex="1" :class="selected === 1 ? 'top-tab-selected' : ''" @click="changeTab(1)">
						<el-badge :value="sysNum" :max="99" :hidden="sysNum == 0" class="item">
							{{$t('messageCenter.systemNotice')}}</el-badge>
					</div>
					<div data-tabindex="2" :class="selected === 2 ? 'top-tab-selected' : ''" @click="changeTab(2)">
						<el-badge :value="orderNum" :max="99" :hidden="orderNum == 0" class="item">
							{{$t('messageCenter.orderMessage')}}</el-badge>
					</div>
				</div>
				<!--list-->
				<div v-if="selected === 1 && totalData1.length > 0" class="msg-list">
					<MessageItem v-for="(item,index) in nowRender1" :content="item.messageContent"
						:time="item.createTime" :read-state="item.readState"
						:type-text="item.messageType === 1 ? $t('messageCenter.messageClass.payMsg') : (item.messageType === 2 ? $t('messageCenter.messageClass.confirmMsg') : $t('messageCenter.messageClass.jumpMsg'))"
						:show-btn="showBtn"
						:btn-text="item.messageType === 1 ? $t('messageCenter.messageClass.toPay') : (item.messageType === 2 ? (item.readState <= 0 ? $t('messageCenter.messageClass.clickConfirm') : $t('messageCenter.messageClass.confirm')) : $t('messageCenter.messageClass.clickJump'))"
						:message-type="item.messageType" :entity-id="item.id" @componentClick="sysBtn"
						v-bind:key="item.id" :index="index" :link="item.link" :orderNo="item.orderNo"
						:orderType="item.orderType" />
					<el-pagination :hide-on-single-page="false" layout="prev,pager,next" :total="total1"
						:page-size="pageSize" @next-click="nextOrPrev" @prev-click="nextOrPrev"
						@current-change="currentChange"></el-pagination>
				</div>
				<div class="msg-list none-data"
					v-if="(selected === 1 && totalData1.length === 0)||(selected === 2 && totalData2.length === 0)">
					{{$t('messageCenter.noData')}}...
				</div>
				<div v-if="selected === 2  && totalData1.length > 0" class="msg-list">
					<MessageItem v-for="(item,index) in nowRender2" :content="item.content" :time="item.createTime"
						:typeText="item.putName" :read-state="item.readNum" icon="el-icon-chat-dot-round"
						:show-btn="showBtn" :total="total1" :page-size="pageSize" :entity-id="index + ''"
						@componentClick="orderBtn" :message-type="item.messageType" v-bind:key="item.id" />
					<el-pagination :hide-on-single-page="false" layout="prev,pager,next" :total="total2"
						:page-size="pageSize" @next-click="nextOrPrev" @prev-click="nextOrPrev"
						@current-change="currentChange"></el-pagination>
				</div>
			</div>
		</div>
		<!--聊天窗口-->
		<MessageWindow v-if="showChatWindow" @closeWindow="closeWindowFn" :getId="chatParams.getId"
			:objectId="chatParams.objectId" :objType="chatParams.objType"></MessageWindow>
		<!--footer-->
		<FooterModle></FooterModle>
	</div>
</template>

<script>
	import WNav from "../../assembly/WhiteNav";
	import LoginPop from "@/components/assembly/LoginPop.vue"; //登录弹窗
	import FooterModle from "../../assembly/Footer"
	import Back from '../../../components/assembly/Back';
	import MessageItem from './MessageItem';
	import {
		Message,
		Loading
	} from 'element-ui';
	import MessageWindow from './MessageWindow';

	export default {
		name: "mymessage",
		components: {
			WNav,
			FooterModle,
			Back,
			MessageItem,
			MessageWindow
		},
		data() {
			return {
				nowRender1: [], //当前渲染的系统消息
				nowRender2: [], //当前渲染的订单消息
				totalData1: [], //系统消息
				totalData2: [], //订单消息
				selected: 1,
				pageSize: 10,
				pageNum1: 1,
				pageNum2: 1,
				canLoading1: true,
				canLoading2: true,
				total1: 1,
				total2: 1,
				showBtn: true,
				token: '',
				//聊天窗口
				showChatWindow: false,
				chatParams: {
					getId: '',
					objectId: '',
					objType: ''
				},
				orderNum: 0,
				sysNum: 0
			}
		},
		created: function() {
			this.token = sessionStorage.getItem('token');
			this.tabChangeDataInit('1');
			this.orderNews()
		},
		methods: {
			//关闭弹窗
			closeWindowFn() {
				this.showChatWindow = false;
			},
			//订单消息点击沟通
			orderBtn({
				messageType = null,
				entityId = ''
			}) {
				//这里的e的值留用后期扩展
				//找出getId和objectId,传给聊天窗口组件
				let item = this.totalData2[entityId];
				let getId = item.getId === 'Y' ? item.putId : item.getId,
					objectId = item.objectId;
				let objType = item.objectType;
				if (!getId || !objectId) {
					this.$message({
						type: 'error',
						message: this.$t('messageCenter.loadMsgErr')
					});
					return;
				}
				this.chatParams = {
					getId,
					objectId,
					objType
				};
				this.showChatWindow = true;
			},
			//系统消息按钮
			sysBtn({
				messageType = null,
				entityId = '',
				index
			}) {
				if (!messageType) return;
				//确认
				let confirm = (entity, type) => {
					this.$post('api/message/other/list', {
						messageId: entityId,
						token: this.token
					}).then(res => {
						if (type === 1) {
							let types = this.nowRender1[index].orderType == 1 ? 0 : 1
							// 成品订单详情
							this.$router.push(
								`/order/orderDetail?id=${this.nowRender1[index].orderNo}&type=${types}`
							);
							return;
						}
						if (type === 3) {
							this.nowRender1[index].readState = 1
							return;
						}
						if (res.code === 0) {
							//确认消息
							this.nowRender1[index].readState = 1
							this.tabChangeDataInit('1')
							this.$message({
								type: 'success',
								message: this.$t('messageCenter.messageClass.confirmSuccess')
							});
							return;
						}
						this.$message({
							type: 'error',
							message: this.$t('messageCenter.messageClass.confirmError')
						});
					});
				};
				switch (parseInt(messageType)) {
					//支付消息
					case 1:
						//跳转消息
					case 3:
						confirm(entityId, parseInt(messageType));
						break;
					case 2: {
						//确认消息点击事件触发
						this.$confirm(this.$t('messageCenter.confirmTitle'), this.$t('publicText.title'), {
							confirmButtonText: this.$t('publicText.sure'),
							cancelButtonText: this.$t('publicText.cancel'),
							type: 'primary'
						}).then(() => {
							confirm(entityId, parseInt(messageType));
						}).catch(() => {
							this.$message({
								type: 'info',
								message: this.$t('publicText.cancel') + this.$t('publicText.sure')
							});
						});
					}
					break; //确认消息
				}
			},
			//上一页下一页
			nextOrPrev(page) {
				this.pageNum1 = page
				this.pageNum2 = page
				this.tabChangeDataInit(this.selected + '');
			},
			//当 当前页改变时
			currentChange(page) {
				this.pageNum1 = page
				this.pageNum2 = page
				this.tabChangeDataInit(this.selected + '');
			},
			changeTab(e) {
				this.total1 = 0
				this.total2 = 0
				this.pageNum2 = '1'
				this.pageNum1 = '1'
				this.selected = e;
				this.tabChangeDataInit(e + '');
			},
			//订单消息数量
			orderNews() {
				this.$get('api/order/message/chat/list', {
					token: this.token,
					pageSize: this.pageSize,
					pageNum: 1
				}).then(res => {
					if (res.code === 0) {
						this.orderNum = res.params.unReadCount
					}
				});
			},
			//系统消息
			tabChangeDataInit(tab) {
				this['canLoading' + tab] = false;
				let loading = Loading.service({
					lock: true,
					background: 'rgba(0, 0, 0, 0)',
					text: 'loading...',
				});
				this.$get(tab === '1' ? 'api/message/other/list' : 'api/order/message/chat/list', {
					token: this.token,
					pageSize: this.pageSize,
					pageNum: this['pageNum' + tab]
				}).then(res => {
					loading.close();
					if (res.code === 0) {
						if (res.data.length === 0) {
							this['canLoading' + tab] = false;
							return;
						}
						if (tab === '1') {
							this.sysNum = res.params.unReadCount
						} else {
							this.orderNum = res.params.unReadCount
						}
						this['nowRender' + tab] = res.data;
						this['totalData' + tab] = res.data;
						this.total1 = res.params.totalDataCounts
						this.total2 = res.params.totalDataCounts
						this['canLoading' + tab] = res.data.length >= this.pageSize;
						if (this['canLoading' + tab]) this['pageNum' + tab]++;
						return;
					}
				});
			}
		}
	}
</script>

<style scoped>
	.content-main {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		min-height: 100vh;
	}

	.center-box {
		flex: 1;
	}

	/*中间消息面板*/
	.content-box {
		background: #fff;
		box-shadow: 0 7px 11px 0 rgba(231, 231, 231, 0.7);
		border-radius: 2px;
		padding-bottom: 40px;
		margin-bottom: 50px;
	}

	/* tab */
	.top-tab {
		margin-top: 20px;
		display: flex;
		border-bottom: 1px solid #e7e7e7;
	}

	.top-tab>div {
		padding-bottom: 30px;
		margin: auto 20px;
		height: 100%;
		text-align: center;
		color: #666666;
		font-size: 16px;
	}

	/*没有数据时的显示样式*/
	.none-data {
		font-size: 16px;
		color: #666;
		margin-top: 20px;
	}

	.top-tab-selected {
		color: #000 !important;
		border-bottom: 2px solid #000;
	}
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/message/MyMessage.vue